// extracted by mini-css-extract-plugin
export default {"qrCode":"_45cfee06"};